import { combineReducers } from "redux";
import jobHistoryItems from "./jobHistoryItems";

const jobHistory = combineReducers({
  jobHistoryItems
});

export default jobHistory;
